import getAuthToken from "../../../auth/getAuthToken";

const getAuthorizationHeader = async () => {
    const token = await getAuthToken();
    return `Bearer ${token}`;
}

export default getAuthorizationHeader;